// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__1m1Ex","content":"Page_content__1YS69","scrollingDisabled":"Page_scrollingDisabled__1EVy1"};